module.exports = __webpack_public_path__ + "img/tv-100x140.a7b652a3.jpg";